var lory: LoryStatic = require('lory.js').lory;

(window as any).initCarousel = function (carouselId: string, itemsPerSlide: number, makeGlobal = false) {
    const carouselItem = document.getElementById(carouselId);

    const infiniteBuffer = itemsPerSlide;

    if (carouselItem) {
        const loryOptions: LoryOptions = {
            enableMouseEvents: true,
            infinite: itemsPerSlide,
            slideSpeed: 800,
            // linear transition 
            ease: 'cubic-bezier(0, 0, 1, 1)'
        };

        let dot_count = carouselItem.querySelectorAll('.js_slide').length;
        let dot_container = carouselItem.querySelector('.js_dots');
        let dot_list_item = document.createElement('li');
        let nextBtn = carouselItem.querySelector('.js_next') as HTMLElement;
        let prevBtn = carouselItem.querySelector('.js_prev') as HTMLElement;
        dot_list_item.tabIndex = 0;

        function handleDotEvent(e) {
            if (e.type === 'before.lory.init') {
                for (var i = 0, len = dot_count; i < len; i++) {
                    var clone = dot_list_item.cloneNode() as HTMLElement;
                    clone.innerHTML = `<span class="visually-hidden">Select slide ${i + 1}`;
                    dot_container.appendChild(clone);
                }
                dot_container.children[0].classList.add('active');
            }
            if (e.type === 'after.lory.init') {
                for (var i = 0, len = dot_count; i < len; i++) {
                    dot_container.children[i].addEventListener('click', evt => {
                        if (makeGlobal) {
                            (window as any)[carouselId].slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                        }
                        else {
                            carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                        }
                    });
                    dot_container.children[i].addEventListener('keyup', (evt: KeyboardEvent) => {
                        if (evt.which == 13) {
                            if (makeGlobal) {
                                (window as any)[carouselId].slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                            }
                            else {
                                carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                            }
                        }
                    });
                }
                nextBtn.addEventListener('keyup', (evt: KeyboardEvent) => {
                    if (evt.which == 13) {
                        if (makeGlobal) {
                            (window as any)[carouselId].next();
                        }
                        else {
                            carouselContainer.next();
                        }
                    }
                });
                prevBtn.addEventListener('keyup', (evt: KeyboardEvent) => {
                    if (evt.which == 13) {
                        if (makeGlobal) {
                            (window as any)[carouselId].prev();
                        }
                        else {
                            carouselContainer.prev();
                        }
                    }
                });
            }
            if (e.type === 'after.lory.slide') {
                for (var i = 0, len = dot_container.children.length; i < len; i++) {
                    dot_container.children[i].classList.remove('active');
                }
                dot_container.children[(e.detail.currentSlide - infiniteBuffer + dot_count) % dot_count].classList.add('active'); //complex to reference because of the "infinite" thing
            }
            if (e.type === 'on.lory.resize') {
                for (var i = 0, len = dot_container.children.length; i < len; i++) {
                    dot_container.children[i].classList.remove('active');
                }
                dot_container.children[0].classList.add('active');
            }
        }
        carouselItem.addEventListener('before.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.slide', handleDotEvent);
        carouselItem.addEventListener('on.lory.resize', handleDotEvent);

        let carouselContainer = null;

        if (makeGlobal) {
            (window as any)[carouselId] = lory(carouselItem, loryOptions);
        }
        else {
            carouselContainer = lory(carouselItem, loryOptions);
        }

        /* Automatic transition 
           Dev Notes: The transition speed is the property available only for the home page carousel.
           This property is used as a condition to automate the carousel rotation.
        */
        var transitionSpeed = carouselItem.getAttribute("data-transition-speed");
        if (transitionSpeed != null) {
            var notDesktop = window.innerWidth <= 768;
            if (notDesktop) {
                window.cancelAnimationFrame(reqAnimation);
            }
            else {
                var autoSlide, interval, startTime, currentTime, elapsed, reqAnimation;
                var playPause = document.getElementById("carouselPlayPauseJS");
                var playPauseSvg = playPause.querySelector("svg use");
                var sliderButton = document.querySelector(".carousel-buttons-inner-js");

                startAnimating(transitionSpeed);

                function startAnimating(speed) {
                    interval = (speed * 1000);
                    autoSlide = true;
                    sliderButton.addEventListener('click', (e) => {
                        autoSlide = false;
                        startTime = Date.now();
                        nextSlide();
                    });

                    if (autoSlide) {
                        startTime = Date.now();
                        animate();
                    }
                }

                function animate() {
                    reqAnimation = requestAnimationFrame(animate);
                    nextSlide();
                }

                function nextSlide() {
                    currentTime = Date.now();
                    elapsed = currentTime - startTime;

                    if (elapsed > interval) {
                        startTime = currentTime - (elapsed % interval);
                        if (makeGlobal) {
                            (window as any)[carouselId].next();
                        }
                        else {
                            carouselContainer.next();
                        }
                    }
                }

                playPause.addEventListener('click', (e) => {
                    var xlinkHref = 'xlink:href';
                    var svg = playPauseSvg.getAttribute(xlinkHref);
                    var playPauseElement = document.getElementById("playPauseTextJS")
                    var playPauseText: string;
                    if (svg.indexOf('play') != -1) {
                        startAnimating(transitionSpeed);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-pause");
                        playPauseText = "Stop automatic transition";
                        playPause.setAttribute('data-is-paused', 'false');
                    }
                    else {
                        window.cancelAnimationFrame(reqAnimation);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-play");
                        playPauseText = "Start automatic transition";
                        playPause.setAttribute('data-is-paused', 'true');
                    }
                    playPauseElement.innerHTML = playPauseText;
                });
            }
        }
    }
}

let tag = document.createElement('script');
tag.src = "https://www.youtube.com/player_api";
let firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

let vimeoTag = document.createElement('script');
vimeoTag.src = "https://player.vimeo.com/api/player.js";
firstScriptTag.parentNode.insertBefore(vimeoTag, firstScriptTag);

declare let YT: any;
declare let Vimeo: any;

(window as any).onYouTubePlayerAPIReady = function () {
    let youtubeVideos = document.querySelectorAll('.youtube-js');
    let youtubeVideosArray = Array.prototype.slice.call(youtubeVideos);

    if (youtubeVideosArray) {
        youtubeVideosArray.forEach(function (video) {
            new YT.Player(video, {
                playerVars: {
                    'rel': 0,
                    'showinfo': 0,
                    'controls': 0,
                },
                events: {
                    'onReady': onReady,
                    'onStateChange' : stateChange
                }
            });
        })
    }
}

window.addEventListener('load', function () {
    let vimeoVideos = Array.prototype.slice.call(document.querySelectorAll('.vimeo-js'));

    if (vimeoVideos) {
        vimeoVideos.forEach(function (video) {
            let player = new Vimeo.Player(video);
            let btnContainer = video.closest('.home-hero');  
            let btn = null;

            if (btnContainer) {
                btn = btnContainer.querySelector('#pausePlayVideo');
            }
            else {
                btn = video.closest('.multimedia-video').querySelector('#pausePlayVideo');
            }

            if (btn) {
                player.on('play', function () {
                    setPausePlayIcons('play', btn);
                })

                player.on('pause', function () {
                    setPausePlayIcons('pause', btn);
                })
            }
        })
    }
})

function stateChange(event) {
    const videoObject = event.target;
    const videoIframe = videoObject.getIframe();

    let playerState = videoObject.getPlayerState();
    let pausePlayBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#pausePlayVideo') : videoIframe.closest('.js_slide') != null ? videoIframe.closest('.js_slide').querySelector('#pausePlayVideo') : null;

    // if video playing
    if (playerState == 1) {
        setPausePlayIcons('play', pausePlayBtn);
    }
    // if video paused or ended
    else if (playerState == 2 || playerState == 0) {
        setPausePlayIcons('pause', pausePlayBtn);
    }
}

function onReady(event) {
    const videoObject = event.target;
    const videoIframe = videoObject.getIframe();

    let pausePlayBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#pausePlayVideo') : null;
    if (pausePlayBtn != null) {
        pausePlayBtn.addEventListener('click', function () {
            playPause(pausePlayBtn, videoObject)
        })
    }

    let playBtn = videoIframe.closest('.multimedia-item') != null ? videoIframe.closest('.multimedia-item').querySelector('.home-hero-play') : null;
    if (playBtn != null) {
        playBtn.addEventListener('click', function () {
            playPause(playBtn, videoObject)
        })
    }

    let thumbnails = videoIframe.closest('.multimedia-item') != null ? videoIframe.closest('.multimedia-item').querySelectorAll('.multimedia-video-thumbnail') : null;
    if (thumbnails != null) {
        thumbnails.forEach(function (thumbnail) {
            thumbnail.addEventListener('click', function () {
                playPause(thumbnail, videoObject)
            })
        })
    }

    let muteUnmuteBtn = videoIframe.closest('.home-hero') != null ? videoIframe.closest('.home-hero').querySelector('#muteUnmuteVideo') : null;
    if (muteUnmuteBtn != null) {
        muteUnmuteBtn.addEventListener('click', function () {
            muteUnmute(muteUnmuteBtn, videoObject)
        })
    }
}

function setPausePlayIcons(state, button) {
    if (state == 'pause') {
        let carouselPauseBtn = document.querySelector('#carouselPlayPauseJS') as HTMLElement;
        if (carouselPauseBtn) {
            let carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');

            if (carouselPauseState == 'true') {
                carouselPauseBtn.click();
            }
        }

        let videoContainer = button.closest('.home-hero');

        if (videoContainer) {
            let thumbnailOverride = videoContainer.querySelector('.home-hero-bg-override');
            if (thumbnailOverride) {
                thumbnailOverride.classList.remove('home-hero-bg-override-hidden');
            }

            let thumbnailOverrideMobile = videoContainer.querySelector('.home-hero-bg-override-mobile');
            if (thumbnailOverrideMobile) {
                thumbnailOverrideMobile.classList.remove('home-hero-bg-override-mobile-hidden');
            }
        }

        button.classList.remove('home-hero-pause');
        button.classList.add('home-hero-play');
    }
    else if (state == 'play') {
        let carouselPauseBtn = document.querySelector('#carouselPlayPauseJS') as HTMLElement;
        if (carouselPauseBtn) {
            let carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');

            if (carouselPauseState == 'false') {
                carouselPauseBtn.click();
            }
        }

        let videoContainer = button.closest('.home-hero');

        if (videoContainer) {
            let thumbnailOverride = videoContainer.querySelector('.home-hero-bg-override');
            if (thumbnailOverride) {
                thumbnailOverride.classList.add('home-hero-bg-override-hidden');
            }

            let thumbnailOverrideMobile = videoContainer.querySelector('.home-hero-bg-override-mobile');
            if (thumbnailOverrideMobile) {
                thumbnailOverrideMobile.classList.add('home-hero-bg-override-mobile-hidden');
            }

            let muteUnmuteBtn = videoContainer.querySelector('#muteUnmuteVideo') as HTMLElement;
            if (muteUnmuteBtn.hasAttribute('disabled')) {
                muteUnmuteBtn.removeAttribute('disabled');
                muteUnmuteBtn.classList.add('clicked-js');
            }
        }

        button.classList.remove('home-hero-play');
        button.classList.add('home-hero-pause');
    }
}

function setMuteUnmuteIcons(state, button) {
    let carouselPauseBtn = document.querySelector('#carouselPlayPauseJS') as HTMLElement;

    if (state == 'mute') {
        if (carouselPauseBtn) {
            let carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');

            if (carouselPauseState == 'true') {
                carouselPauseBtn.click();
            }
        }

        button.classList.remove('home-hero-mute');
        button.classList.add('home-hero-unmute');
    }
    else if (state == 'unmute') {
        if (carouselPauseBtn) {
            let carouselPauseState = carouselPauseBtn.getAttribute('data-is-paused');

            if (carouselPauseState == 'false') {
                carouselPauseBtn.click();
            }
        }

        button.classList.remove('home-hero-unmute');
        button.classList.add('home-hero-mute');
    }
}

function playPause(pausePlayBtn, video) {
    let videoContainer = pausePlayBtn.closest('.home-hero');

    let playerState = video.getPlayerState();
    if (playerState == 1) {
        video.pauseVideo();
        setPausePlayIcons('pause', pausePlayBtn);
    }
    else {
        video.playVideo();
        setPausePlayIcons('play', pausePlayBtn);
    }
}

function muteUnmute(muteUnmuteBtn, video) {
    if (video.isMuted()) {
        video.unMute();
        setMuteUnmuteIcons('unmute', muteUnmuteBtn);
    }
    else {
        video.mute();
        setMuteUnmuteIcons('mute', muteUnmuteBtn);
    }
}

window.addEventListener('load', function () {
    let videos = document.querySelectorAll('.home-hero iframe, .home-hero video');

    if (videos) {
        setDimensions();

        window.addEventListener('resize', function () {
            setDimensions();
        })
    }

    function setDimensions() {
        let videosArray = Array.prototype.slice.call(videos);

        videosArray.forEach(function (video) {
            let videoContainer = video.closest('.carousel-container');
            let headerWidth = videoContainer.offsetWidth;
            let headerHeight = videoContainer.offsetHeight;

            video.style.width = `${Math.max(headerWidth, (headerHeight * 16 / 9))}px`;
            video.style.height = `${Math.max((headerHeight + 480), (headerWidth * 9 / 16))}px`;

            let videoThumbnail = videoContainer.querySelector('.home-hero-bg-image');
            videoThumbnail.style.height = `${Math.max((headerHeight + 480), (headerWidth * 9 / 16))}px`;
        })
    }

    let pausePlayButtons = document.querySelectorAll('#pausePlayVideo[data-video-type="Vimeo"], #pausePlayVideo[data-video-type="Embedded"], .home-hero-play[data-video-type="Vimeo"], .home-hero-play[data-video-type="Embedded"], .multimedia-video-thumbnail[data-video-type="Vimeo"], .multimedia-video-thumbnail[data-video-type="Embedded"]');
    let muteUnmuteButtons = document.querySelectorAll('#muteUnmuteVideo[data-video-type="Vimeo"], #muteUnmuteVideo[data-video-type="Embedded"]');

    if (pausePlayButtons) {
        let pausePlayButtonsArray = Array.prototype.slice.call(pausePlayButtons);

        pausePlayButtonsArray.forEach(function (button) {
            button.addEventListener('click', function () {
                let videoId = button.getAttribute('data-associated-video');
                let video = document.getElementById(videoId);
                let videoType = button.getAttribute('data-video-type');

                if (videoType == "Vimeo") {
                    vimeoVideoPausePlay(button);
                }
                else {
                    embeddedVideoPausePlay(button);
                }
            })
        })
    }

    if (muteUnmuteButtons) {
        let muteUnmuteButtonsArray = Array.prototype.slice.call(muteUnmuteButtons);

        muteUnmuteButtonsArray.forEach(function (button) {
            button.addEventListener('click', function () {
                let videoId = button.getAttribute('data-associated-video');
                let video = document.getElementById(videoId);
                let videoType = button.getAttribute('data-video-type');

                if (videoType == "Vimeo") {
                    vimeoVideoMuteUnmute(button);
                }
                else {
                    embeddedVideoMuteUnmute(button);
                }
            })
        })
    }

    function vimeoVideoPausePlay(button) {
        let videoContainer = button.closest('.home-hero');

        if (videoContainer == null) {
            videoContainer = button.closest('.multimedia-item');
        }

        let video = videoContainer.querySelector('iframe');
        let player = new Vimeo.Player(video);

        player.getPaused().then(function (paused) {
            if (paused) {
                player.play();
            }
            else {
                player.pause();
            }
        })
    }

    function vimeoVideoMuteUnmute(button) {
        let videoContainer = button.closest('.home-hero');
        let video = videoContainer.querySelector('iframe');
        let player = new Vimeo.Player(video);

        player.getVolume().then(function (volume) {
            if (volume > 0) {
                player.setVolume(0);
                setMuteUnmuteIcons('mute', button);
            }
            else {
                player.setVolume(1);
                setMuteUnmuteIcons('unmute', button);
            }
        })
    }

    function embeddedVideoPausePlay(button) {
        let videoContainer = button.closest('.home-hero');

        if (videoContainer == null) {
            videoContainer = button.closest('.multimedia-item');
        }

        let video = videoContainer.querySelector('video');

        if (video != null && video.paused != null && video.paused == true) {
            video.play();
            setPausePlayIcons('play', button);
        } else {
            video.pause();
            setPausePlayIcons('pause', button);
        }
    }

    function embeddedVideoMuteUnmute(button) {
        let videoContainer = button.closest('.home-hero');
        let video = videoContainer.querySelector('video');

        if (video.muted == true) {
            video.muted = false;
            setMuteUnmuteIcons('unmute', button);
        } else {
            video.muted = true;
            setMuteUnmuteIcons('mute', button);
        }
    }

    function updateMobileAutoPlayControls() {
        let autoplayVideos = Array.prototype.slice.call(document.querySelectorAll('.auto-play-js'));

        if (autoplayVideos) {
            autoplayVideos.forEach(function (video) {
                let pauseBtn = video.closest('.home-hero').querySelector('.home-hero-pause');

                if (window.innerWidth <= 768) {
                    if (pauseBtn) {
                        pauseBtn.classList.remove('home-hero-pause');
                        pauseBtn.classList.add('home-hero-play');
                    }

                    if (video.classList.contains('native-video')) {
                        video.pause();
                    }
                }
            })
        }
    }

    function disableAudioControls() {
        let homeAreaCarousel = document.querySelector('#homeheroCarousel');

        if (homeAreaCarousel) {
            let audioControls = Array.prototype.slice.call(homeAreaCarousel.querySelectorAll('#muteUnmuteVideo'));

            if (audioControls) {
                audioControls.forEach(function (control) {
                    let isAutoPlay = control.closest('.home-hero').querySelector('.auto-play-js');
                    let autoPlayOnDesktop = isAutoPlay != null && window.innerWidth > 768;

                    if (!control.hasAttribute('disabled') && window.innerWidth < 769 && !control.classList.contains('clicked-js')) {
                        control.setAttribute('disabled', '');
                    }
                })
            }
        }
    }

    updateMobileAutoPlayControls();
    disableAudioControls();

    window.addEventListener('resize', function () {
        updateMobileAutoPlayControls();
        disableAudioControls();
    })
})


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/common/carousel.ts